import React from 'react';
import { Modal, ModalBody } from 'reactstrap';

export const ModalAlertPwd = ({ toggle, isOpen, response }) => {
  const copyToClipBoard = async (copyMe) => {
    await navigator.clipboard.writeText(copyMe);
  };

  return (
    <Modal
      toggle={() => {
        toggle();
      }}
      isOpen={isOpen}
      zIndex={10000}
      backdrop={'static'}
      centered
    >
      <ModalBody className="text-center">
        <div className="mt-2">
          <lord-icon
            src="https://cdn.lordicon.com/jvihlqtw.json"
            trigger="hover"
            style={{ width: '150px', height: '150px' }}
          ></lord-icon>
          <h4 className="mb-3 mt-4">{response.message}</h4>
          <p className="fs-15 mb-4">
            <strong>Nova Senha:</strong>{' '}
            <span className="text-muted">{response.password}</span>
          </p>
          <div className="hstack gap-2 justify-content-center">
            <button className="btn btn-link" onClick={toggle}>
              Fechar
            </button>
            <button
              className="btn btn-soft-primary"
              onClick={() => copyToClipBoard(response.password)}
            >
              <i className="ri-file-copy-line align-bottom"></i> Copiar Senha
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
